import React from 'react';
import { IconsMap } from "common/maps/icons.map";

interface Props {
  type: string;
  width?: number;
  height?: number;
  className?: string;
}

const SvgIcon = ({ type, width, height, className }: Props) => {
  const IconTag = IconsMap.get(type);
  return (
    IconTag ?
    <IconTag width={width} height={height} className={className} /> :
    null
  )
}

export default SvgIcon;
